import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';

import { AbstractControl } from '@angular/forms';
import { FormControlEx } from '../../../core/component/forms/form-control';
import { VacantRentalObjectService } from '../../service/data/vacant-period.service';

@Component({
    selector: 'app-vacant-period-cooperative-housing-autocomplete',
    templateUrl: './vacant-period-cooperative-housing-autocomplete.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VacantPeriodCooperativeHousingAutocompleteComponent implements OnInit, OnDestroy {
  constructor(private service: VacantRentalObjectService) {}
  ngOnDestroy(): void {
    if (this._subscription) {
      this._subscription.unsubscribe();
      this._subscription = null;
    }
    this.items = null;
  }
  
  private _control: FormControlEx;
  @Input() set control(value: AbstractControl) {
    this._control = value as FormControlEx;
  }
  get control(): FormControlEx {
    return this._control;
  }

  items: any[];

  private _subscription = new Subscription();

  ngOnInit() {
    this._subscription.add(
      this.service.getCooperativeHousing().subscribe(data => (this.items = data))
    );
  }
}
